import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/layout/Header";
import Sidebar from "../components/layout/Sidebar";
import "../components/layout/layout.scss";

interface ILayoutPageProps {
  sidebar?: true;
}

const LayoutPage = (props: ILayoutPageProps) => {
  // props
  const { sidebar } = props;

  return (
    <div className="layout-container">
      <Header />
      <div className="layout-inner">
        {sidebar ? <Sidebar /> : <></>}
        <div className="layout-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default LayoutPage;
